import { sectionContainSlug } from 'lib/taxonomy';


// eslint-disable-next-line max-len
export const ECOMMERCE_ABOUT_URL_TODAY = 'https://www.today.com/shop/everything-you-need-know-about-shop-today-t161374';

export const ECOMMERCE_DISCLAIMER = {
  DEFAULT: 'Our editors independently selected these items because we think you will enjoy them '
    + 'and might like them at these prices. If you purchase something through our links, we may '
    + 'earn a commission. Pricing and availability are accurate as of publish time.',

  PRIME_DAY: 'Prime Day is an event created by Amazon. Our editors independently selected these '
    + 'items because we think you will enjoy them and might like them at these prices. If you '
    + 'purchase something through our links, we may earn a commission. Pricing and availability '
    + 'are accurate as of publish time.',

  TARGET_SHOP_THIS_LIST: 'This content is sponsored by Target. '
    + 'Our editorial team independently selected these products. '
    + 'When you buy through our links, we earn a commission. ',

  SELECT_CUSTOMER: 'Select is editorially independent. We may earn a commission from affiliate '
    + 'partner links. Read more about <a href="https://www.nbcnews.com/select/about" target="_blank">NBC Select</a>.',

  PRODUCT: '<span class="disclaimer__lead-in">DISCLAIMER</span>: Our editors independently '
    + 'selected these items because we think you '
    + 'will enjoy them and might like them at these prices. If you purchase something '
    + 'through our links, we may earn a commission. Pricing and availability are accurate '
    + `as of publish time. <a href="${ECOMMERCE_ABOUT_URL_TODAY}">Learn more about Shop TODAY</a>`,

  SELECT_DEFAULT: 'Select is editorially independent. Our editors selected these deals and items '
    + 'because we think you will enjoy them at these prices. If you purchase something through our '
    + 'links, we may earn a commission. Pricing and availability are accurate as of publish time.',
};

/**
 * @param {Array} subtopics
 * @returns {boolean}
 */
export const containsDealsSubtopic = (subtopics) => {
  const dealsSubtopic = 'deals';

  const containsSubtopic = Array.isArray(subtopics)
    && !!(subtopics.find(({ slug }) => slug === dealsSubtopic));

  return containsSubtopic;
};

/**
 * @param {Array} labels
 * @returns {boolean}
 */
export const containsShopDealsLabel = (labels) => {
  const shopDealsLabel = 'shop-deals';

  const labelsContainsShopDealsLabel = Array.isArray(labels)
    && !!(labels.find(({ slug }) => slug === shopDealsLabel));

  return labelsContainsShopDealsLabel;
};

/**
 * @param {Array} labels
 * @returns {boolean}
 */
export const containsSponsoredCommerceLabel = (labels) => {
  const sponsoredCommerceLabel = 'sponsored-commerce';

  const containsLabel = Array.isArray(labels)
    && !!(labels.find(({ slug }) => slug === sponsoredCommerceLabel));

  return containsLabel;
};

/**
 * @param {Array} sections
 * @returns {boolean}
 */
export const containsShoppingSection = (sections) => {
  const shoppingSectionSlug = 'shopping';

  return sectionContainSlug(sections, shoppingSectionSlug);
};

/**
 * @param {object} source
 * @returns {boolean}
 */
export const isSourceFromStackCommerce = (source) => {
  const organizationName = source?.organization?.name;

  const organizationIsStackCommerce = (organizationName === 'StackCommerce');

  return organizationIsStackCommerce;
};

/**
 * @param {string} vertical
 * @param {object} article
 * @returns {string}
 */
export const getEcommerceArticleType = (vertical, article = {}) => {
  const { ecommerceEnabled, source, taxonomy = {} } = article;
  const { labels, subtopics, sections } = taxonomy;

  const articleContainShopDealsLabel = containsShopDealsLabel(labels);
  const articleContainsSponsoredCommerceLabel = containsSponsoredCommerceLabel(labels);

  const articleContainDealsSubtopic = containsDealsSubtopic(subtopics);

  const articleContainsShoppingSection = containsShoppingSection(sections);
  const articleDoesNotContainShoppingSection = !articleContainsShoppingSection;

  const articleSourceIsStackCommerce = isSourceFromStackCommerce(source);

  const isTodayVertical = (vertical === 'today');
  const isNotTodayVertical = !isTodayVertical;

  const isNBCNewsVertical = (vertical === 'news');

  const isTodayDeals = ecommerceEnabled
    && isTodayVertical
    && (articleContainShopDealsLabel || articleContainDealsSubtopic);
  if (isTodayDeals) {
    return 'todayDeals';
  }

  const isTodaySponsoredCommerce = ecommerceEnabled
    && isTodayVertical
    && articleContainsSponsoredCommerceLabel;
  if (isTodaySponsoredCommerce) {
    return 'todaySponsoredCommerce';
  }

  const isTodayGeneralCommerce = ecommerceEnabled && isTodayVertical;
  if (isTodayGeneralCommerce) {
    return 'todayGeneralCommerce';
  }

  const isNBCNewsGeneralCommerceStackCommerce = ecommerceEnabled
    && isNBCNewsVertical
    && articleSourceIsStackCommerce;
  if (isNBCNewsGeneralCommerceStackCommerce) {
    return 'nbcNewsGeneralCommerceStackCommerce';
  }

  const isNBCNewsGeneralCommerceShopToday = ecommerceEnabled
    && isNotTodayVertical
    && articleContainsShoppingSection;
  if (isNBCNewsGeneralCommerceShopToday) {
    return 'nbcNewsGeneralCommerceShopToday';
  }

  const isNBCNewsGeneralCommerce = ecommerceEnabled
    && isNotTodayVertical
    && articleDoesNotContainShoppingSection;
  if (isNBCNewsGeneralCommerce) {
    return 'nbcNewsGeneralCommerce';
  }

  return 'nbcNewsGeneric';
};

/**
 * @param {string} ecommerceArticleType
 * @returns {boolean}
 */
export const shouldDisplayEcommerceDisclaimerAlternateFormat = (ecommerceArticleType) => {
  const shouldDisplayAlternate = ecommerceArticleType === 'nbcNewsGeneralCommerceStackCommerce';
  return shouldDisplayAlternate;
};

/**
 * Helper function to identify Amazon URLs.
 * @param {string} url
 * @returns {boolean}
 */
export function isAmazonUrl(url) {
  try {
    const urlObj = new URL(url);

    const hostname = urlObj.hostname.toLowerCase();

    return hostname === 'amazon.com' || hostname.endsWith('.amazon.com');
  } catch (error) {
    return false;
  }
}
/**
 * Parses an Amazon URL to extract the product ID and tag value
 * @param {string} url - The Amazon URL to parse
 * @returns {object} An object containing productId and tag, or an empty object
 */
export function getAmazonUrlProductAsinAndAssociateTag(url) {
  if (!url || typeof url !== 'string' || !isAmazonUrl(url)) {
    return {};
  }

  try {
    const urlObj = new URL(url);

    const pathSegments = urlObj
      .pathname.split('/')
      .filter((segment) => segment.length > 0);

    if (pathSegments.length === 0) {
      return {};
    }

    const productAsin = pathSegments[pathSegments.length - 1];

    const associateTag = urlObj.searchParams.get('tag');

    return {
      productAsin,
      associateTag,
    };
  } catch (error) {
    return {};
  }
}

/**
 * Returns the tracking object for Amazon Product Offers.
 * @param {Array} products - An array of products.
 * @returns {object|null} An object or null.
 */
export function getAmazonProductOffersTrackingObject(products) {
  const associateTags = [];

  /**
   * Helper function to retrieve Amazon offer from product offers.
   * @param {object} product
   */
  const getAmazonOffer = (product) => {
    const offers = product?.offers || [];
    return offers.find((offer) => offer?.seller?.name === 'Amazon');
  };

  const asinProducts = products
    .map((product) => {
      const offer = getAmazonOffer(product);

      if (!offer) return null;

      const {
        productAsin,
        associateTag,
      } = getAmazonUrlProductAsinAndAssociateTag(offer.externalUrl);

      associateTags.push(associateTag);

      return { asin: productAsin };
    })
    .filter(Boolean); // Remove null values of products that have no Amazon offers

  if (asinProducts.length === 0) return null;

  return {
    accountId: '3219',
    associateTag: associateTags[0],
    products: asinProducts,
  };
}
